module.exports = __webpack_public_path__ + "static/bannerNovo2-3b165f4e5e5fd46d1c79f2ece017d8ff.jpg";